"use client";

import { orpcClient } from "@shared/lib/orpc-client";
import { readConsentLocalStorage } from "./storage-client";

export const CONSENT_SYNC_PENDING_KEY = "sq:consent:sync-pending";
export const CONSENT_LAST_FLOW_KEY = "sq:consent:last-flow";

export function markConsentSyncPending(): void {
	if (typeof window === "undefined") {
		return;
	}
	window.sessionStorage.setItem(CONSENT_SYNC_PENDING_KEY, "1");
}

export function clearConsentSyncPending(): void {
	if (typeof window === "undefined") {
		return;
	}
	window.sessionStorage.removeItem(CONSENT_SYNC_PENDING_KEY);
}

export function isConsentSyncPending(): boolean {
	if (typeof window === "undefined") {
		return false;
	}
	return window.sessionStorage.getItem(CONSENT_SYNC_PENDING_KEY) === "1";
}

export function rememberConsentPublishFlow(flow: string): void {
	if (typeof window === "undefined") {
		return;
	}
	window.sessionStorage.setItem(CONSENT_LAST_FLOW_KEY, flow);
}

export function readConsentPublishFlow(): string {
	if (typeof window === "undefined") {
		return "customize_preferences";
	}
	return (
		window.sessionStorage.getItem(CONSENT_LAST_FLOW_KEY) ??
		"customize_preferences"
	);
}

export async function syncSiteCmpConsentToServer(
	sqid: string,
	flow?: string,
): Promise<boolean> {
	const record = readConsentLocalStorage();
	if (!record) {
		return false;
	}

	try {
		await orpcClient.identity.recordConsent({
			sqid,
			record,
			flow: flow ?? readConsentPublishFlow(),
		});
		clearConsentSyncPending();
		return true;
	} catch {
		markConsentSyncPending();
		return false;
	}
}
